module.exports = __webpack_public_path__ + "media/hit_baggage.96641c93.mp3";